import { useEffect } from 'react'

/**
 * Impede o body de rolar enquanto um painel/modal está aberto.
 *
 * Compensa a largura da barra de rolagem no `padding-right`, senão o conteúdo
 * "salta" horizontalmente no instante em que o menu abre (visível no desktop).
 */
export function useTravaScroll(ativo: boolean): void {
  useEffect(() => {
    if (!ativo) return

    const { overflow, paddingRight } = document.body.style
    const larguraBarra = window.innerWidth - document.documentElement.clientWidth

    document.body.style.overflow = 'hidden'
    if (larguraBarra > 0) document.body.style.paddingRight = `${larguraBarra}px`

    return () => {
      document.body.style.overflow = overflow
      document.body.style.paddingRight = paddingRight
    }
  }, [ativo])
}
